import React from 'react'
import MembershipCard from './MembershipCard/MembershipCard'
import StyledMembershipSelect from './StyledMembershipSelect'

const MembershipSelect = ({ memberships, selected, selectMembership, ...props }) => (
  <StyledMembershipSelect {...props}>
    {memberships.slice(0, 3).map(m => (
      <div key={m.id} onClick={() => selectMembership({ gold: m })}>
        <MembershipCard selected={selected.id === m.id} membership={m} />
      </div>
    ))}
  </StyledMembershipSelect>
)

export default MembershipSelect
